import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esMX from './es-MX.json';
import enUS from './en-US.json';
import { idiomaGuardado } from './idioma';

export const DEFAULT_LOCALE = 'es-MX';

/**
 * Ningún texto de interfaz vive en un componente (ADR-0013). Si un componente
 * necesita una frase, la pide aquí por su clave.
 */
void i18n.use(initReactI18next).init({
  resources: {
    'es-MX': { translation: esMX },
    'en-US': { translation: enUS },
  },
  // El último que se eligió en este navegador; si no, español. Nunca el del navegador.
  lng: idiomaGuardado() ?? DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
});

/**
 * La API devuelve códigos, no frases. Esto los traduce, con un respaldo genérico
 * para un código que todavía no tenga texto: mejor un mensaje útil que uno vacío.
 */
export function translateErrorCode(code: string, params?: Record<string, unknown>): string {
  const key = `error.${code}`;
  const translated = i18n.t(key, params ?? {});
  return translated === key ? i18n.t('error.internal.error') : translated;
}

export default i18n;
